import React, { useRef, useEffect, useState } from 'react';

import { Drawer, Layout } from 'antd';

// CHECK DEVICES
import { isMobileOnly } from 'react-device-detect';

// eslint-disable-next-line import/no-cycle
import { academyConst } from '../academy';

const AdaptiveListAcademy = ({
  state,
  changeState,
  children,
  setShowDrawerButton,
}) => {
  const domRef = useRef(null);

  const [width, setWidth] = useState(window.innerWidth);

  const defaultWidth =
    state.size === academyConst.FULL ? window.innerWidth : state.width;

  useEffect(() => {
    setShowDrawerButton(isMobileOnly || defaultWidth < 1024);
  }, [state.width]);

  useEffect(() => {
    let data = {};

    setShowDrawerButton(isMobileOnly || defaultWidth < 1024);

    if (width < 768) {
      data = {
        width: '100%',
        height: '100%',
        x: 0,
        y: 0,
        size: academyConst.FULL,
      };
    }
    if (state.size === academyConst.WINDOW && window.innerWidth > 768) {
      data = {
        width: width - 100,
      };
    }
    changeState({
      ...data,
    });
  }, [width]);

  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onClose = () => changeState({ visibleDrawer: false });

  return isMobileOnly || defaultWidth < 1024 ? (
    <div ref={domRef} className="site-drawer-render-in-current-wrapper">
      <Drawer
        style={{
          position: 'absolute',
        }}
        title={false}
        placement="left"
        closable={false}
        onClose={onClose}
        visible={state.visibleDrawer}
        zIndex={3010}
        mask={false}
        getContainer={domRef.current}
        width={350}
      >
        {children}
      </Drawer>
    </div>
  ) : (
    <Layout.Sider>{children}</Layout.Sider>
  );
};

export default AdaptiveListAcademy;
